import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEECoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Electrical and Electronics Engineering",
    shortName: "B.E. EEE",
    duration: "4 years",
    description: "Engineering program focused on electrical power systems, electronics, and automation technologies",
    overview: "Bachelor of Engineering in Electrical and Electronics Engineering (B.E. EEE) is a 4-year undergraduate program that combines electrical engineering with electronics engineering. This course covers power systems, electrical machines, control systems, power electronics, and renewable energy technologies, preparing students for careers in power generation, transmission, distribution, and industrial automation.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in electrical systems and electronics"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Basic Electrical Engineering",
          "Programming in C"
        ]
      },
      {
        year: 2,
        subjects: [
          "Circuit Analysis",
          "Electronic Devices and Circuits",
          "Electrical Machines-I",
          "Network Theory",
          "Electromagnetic Theory",
          "Digital Electronics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Power Systems-I",
          "Electrical Machines-II",
          "Control Systems",
          "Power Electronics",
          "Transmission and Distribution",
          "Microprocessors"
        ]
      },
      {
        year: 4,
        subjects: [
          "Power Systems-II",
          "Protection and Switchgear",
          "High Voltage Engineering",
          "Renewable Energy Systems",
          "Industrial Automation",
          "Project Work"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Electrical Engineer",
        "Power Systems Engineer", 
        "Control Systems Engineer",
        "Electronics Design Engineer",
        "Automation Engineer",
        "Power Plant Engineer",
        "Electrical Consultant",
        "Project Manager"
      ],
      industries: [
        "Power Generation Companies",
        "Electrical Equipment Manufacturing",
        "Automation & Control Industry",
        "Renewable Energy Sector",
        "Construction & Infrastructure",
        "Railways & Transportation",
        "Government Organizations (TNEB, BHEL)",
        "Research Institutions"
      ],
      averageSalary: "₹4-7 LPA (Fresher), ₹12-25 LPA (Experienced)",
      topRecruiters: [
        "TNEB, NTPC, BHEL",
        "Siemens, ABB, Schneider",
        "L&T, Godrej",
        "Tata Power, Adani Power",
        "Indian Railways, ISRO",
        "Bajaj Electricals, Havells"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore", 
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Thiagarajar College of Engineering",
        location: "Madurai",
        fees: "₹3,20,000",
        ranking: "NIRF Ranking: 78"
      },
      {
        name: "Kumaraguru College of Technology",
        location: "Coimbatore",
        fees: "₹3,80,000", 
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Circuit Design and Analysis",
      "Power System Protection",
      "PLC Programming",
      "MATLAB/Simulink",
      "AutoCAD Electrical",
      "Power Electronics Design",
      "Control System Design",
      "Electrical Safety Standards",
      "Renewable Energy Technologies",
      "Industrial Automation"
    ],

    futureScope: "Excellent growth prospects with renewable energy expansion, smart grid development, electric vehicles, and industrial automation driving demand for electrical engineers.",

    faqs: [
      {
        question: "What is the difference between EEE and ECE?",
        answer: "EEE focuses more on power systems, electrical machines, and high voltage applications, while ECE emphasizes communication systems, signal processing, and electronic devices."
      },
      {
        question: "Are there good job opportunities in EEE?",
        answer: "Yes, especially with the growing focus on renewable energy, smart grids, and industrial automation. Government sectors like TNEB, NTPC also offer excellent opportunities."
      },
      {
        question: "Can EEE graduates work in software companies?",
        answer: "Yes, many EEE graduates successfully transition to software roles, especially in embedded systems, automation software, and technical sales."
      },
      {
        question: "What are the higher study options after EEE?",
        answer: "M.E./M.Tech in Power Systems, Control Systems, Power Electronics, MBA, or specialized certifications in renewable energy and automation."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEECoursePage;
